var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "10px",
    viewBox: "0 0 13 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Domestic-Jobs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SEARCH-JOBS---I'm-Interested-(Desktop)",
    transform: "translate(-1145.000000, -866.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile-button-share-profile",
    transform: "translate(1131.000000, 858.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile-share-profile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checkmark",
    transform: "translate(14.000000, 8.500000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.67,1.94 L5.84,8.66 C5.25460573,9.0698474 4.47539427,9.0698474 3.89,8.66 L0.34,5.17 C-0.051307319,4.78926566 -0.114438342,4.18320784 0.19,3.73 C0.228937681,3.66445793 0.279816261,3.60679554 0.34,3.56 C0.558285778,3.33642665 0.857536047,3.21037029 1.17,3.21037029 C1.48246395,3.21037029 1.78171422,3.33642665 2,3.56 L4.86,6.4 L11,0.33 C11.4573385,-0.111962483 12.1826615,-0.111962483 12.64,0.33 C13.0258724,0.718387934 13.0844381,1.3249614 12.78,1.78 C12.7482581,1.8365568 12.7114399,1.89011057 12.67,1.94 Z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkWhite);
export default __webpack_public_path__ + "static/media/checkmarkWhite.1acffaeb.svg";
export { ForwardRef as ReactComponent };